import inputMixin from '@/client/extensions/mixins/baseComponents/form/controls/formInput.js'

export default {
  mixins: [inputMixin],

};
